import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Col, FormGroup, Input, Label, Row } from "reactstrap";
import pizzalabel from "../assets/img/pizzalabel.svg";

const ItemsDetail = ({
  id,
  data,
  currency,
  existingCartItem,
  selectedItem,
  setSelectedItem,
}) => {
  const { darkMode, color } = useSelector((state) => state.global);

  const handleChange = (size, price) => {
    setSelectedItem((prev) => {
      const newPrice = Number(price);
      const addonsTotal = prev.addons.reduce(
        (sum, addon) => sum + addon.price * addon.quantity,
        0
      );

      return {
        ...prev,
        size,
        price: newPrice,
        totalPrice: newPrice * prev.quantity + addonsTotal,
      };
    });
  };

  useEffect(() => {
    if (data?.length > 0) {
      const item = data[0];
      setSelectedItem((prev) => ({
        ...prev,
        price: Number(item?.price),
        size: item?.size,
        quantity: 1,
        totalPrice: Number(item?.price),
      }));
    }
  }, [data, setSelectedItem]);

  return (
    <Row className="mx-2 d-flex flex-column justify-content-start align-items-start">
      <h3
        className={
          darkMode
            ? "fs--18 fw--600 mb-0 d-flex flex-column normal-heading-dark"
            : "fs--18 fw--600 mb-0 d-flex flex-column normal-heading"
        }
      >
        Size
      </h3>
      {data &&
        data?.map((item, index) => {
          const isChecked = selectedItem?.size === item?.size;
          return (
            <Col
              className="d-flex justify-content-between align-items-center top_cards__sizes"
              key={index}
            >
              <div className="d-flex justify-content-center align-items-center py-2">
                <FormGroup check className="mx-2">
                  <Label check>
                    <Input
                      type="radio"
                      name="size"
                      value={item?.size}
                      checked={isChecked}
                      onChange={() => handleChange(item?.size, item?.price)}
                      style={{ "--accent-color": `${color}` }}
                    />
                    <img
                      alt="Pizza label"
                      src={item?.image || pizzalabel}
                      width={25}
                      className="mx-2"
                    />
                  </Label>
                </FormGroup>
                <h5
                  className={
                    darkMode
                      ? "mb-0 fs--16 fw--600 normal-heading-dark text-capitalize"
                      : "mb-0 fs--16 fw--600 text-capitalize"
                  }
                >
                  {item?.size}
                </h5>
              </div>
              <h4
                className={
                  darkMode
                    ? "mb-0 fs--16 fw--600 normal-heading-dark"
                    : "mb-0 fs--16 fw--600"
                }
              >
                {currency || "$"}
                <span className="text-sm font-medium text-gray-700">
                  {item?.price === 0 ? "Free" : item?.price}
                </span>
              </h4>
            </Col>
          );
        })}
    </Row>
  );
};

export default ItemsDetail;
